import * as React from "react"
import { createFileRoute, useNavigate } from "@tanstack/react-router"
import Cookies from "js-cookie"

import { env } from "@/env"
import { markDeviceAsTrusted, sendMfaOtp } from "@/lib/api/auth"
import { getUserEmail, isAuthenticated, isMfaEnabled } from "@/lib/auth"
import { useToast } from "@/hooks/use-toast"
import { Button } from "@/components/ui/button"
import {
  Card,
  CardContent,
  CardFooter,
  CardHeader,
  CardTitle,
} from "@/components/ui/card"
import { Icons } from "@/components/icons"

export const Route = createFileRoute("/_auth/trust-device")({
  component: Page,
})

function Page() {
  const email = getUserEmail()
  const urlParams = new URLSearchParams(window.location.search)
  const deviceIdFromUrl = urlParams.get("device_id")
  const deviceIdFromLocalStorage = localStorage.getItem(`device_id-${email}`)
  const [isLoading, setIsLoading] = React.useState(false)
  const navigate = useNavigate({ from: "/trust-device" })
  const { toast } = useToast()

  const userInfo = Cookies.get("user_info")
    ? JSON.parse(Cookies.get("user_info") as string)
    : {}

  const mfaAuthCookie = `mfa-auth-${email}`

  if (deviceIdFromUrl !== deviceIdFromLocalStorage) {
    return (
      <div className="text-2xl font-bold text-gray-600">
        404 - Your Device ID does not match
      </div>
    )
  }

  /* const handleTrustDevice = async () => {
    if (!deviceIdFromUrl || deviceIdFromUrl !== deviceIdFromLocalStorage) return

    setIsLoading(true)

    try {
      await markDeviceAsTrusted(deviceIdFromUrl)
      localStorage.setItem(`device_trusted-${email}`, "true")

      if (isMfaEnabled()) {
        const mfaAuth = Cookies.get(`mfa-auth-${email}`)
        if (mfaAuth === "true") {
          navigate({ to: "/" })
        } else {
          sendMfaOtp()
          navigate({ to: "/mfa-auth" })
        }
      } else {
        navigate({ to: "/" })
      }
    } catch (error) {
      toast({
        description: "Failed to mark device as trusted!",
        variant: "destructive",
      })
    } finally {
      setIsLoading(false)
    }
  } */

  const handleTrustDevice = async () => {
    if (!deviceIdFromUrl || deviceIdFromUrl !== deviceIdFromLocalStorage) return

    setIsLoading(true)

    try {
      await markDeviceAsTrusted(deviceIdFromUrl)

      localStorage.setItem(`device_trusted-${email}`, "true")

      if (!isMfaEnabled()) {
        Cookies.set(mfaAuthCookie, "true", {
          expires: (1 / 1440) * env.SESSION_DURATION,
        })
        navigate({ to: "/" })
      } else {
        await sendMfaOtp()
        navigate({ to: "/mfa-auth" })
      }
    } catch (error) {
      toast({
        description: "Failed to mark device as trusted!",
        variant: "destructive",
      })
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <div className="w-full px-5">
      <div className="z-20 flex flex-col items-center md:mr-10 md:justify-center lg:mr-0">
        <Icons.himo height="120px" width="120px" />
      </div>
      <div className="flex flex-col items-center justify-center md:flex-row md:text-center">
        <div className="relative md:h-[80px] md:w-[150px]">
          <Icons.phoneTrustedDark className="hidden md:ml-12 md:block" />
        </div>
        <div className="flex flex-col items-center justify-center text-center md:ml-6 md:items-start md:text-start">
          <h1 className="font-gilroy-bold text-2xl text-primary">
            Trust Device
          </h1>
          <p className="font-gilroy-thin text-sm opacity-50 md:mt-1">
            Do you want to mark this device as trusted?
          </p>
        </div>
        <div className="relative mt-4 md:hidden">
          <Icons.phoneTrustedDark height="40px" width="40px" />
        </div>
      </div>
      <div className="mt-3 flex justify-center">
        <Button
          disabled={isLoading}
          className="w-full rounded-full"
          onClick={handleTrustDevice}
        >
          {isLoading && <Icons.loader className="mr-2 animate-spin" />}
          Trust Device
        </Button>
      </div>
      <div className="mt-10 flex items-center justify-center space-x-2 md:justify-end">
        <p className="font-gilroy-thin text-[16px]">By</p>
        <Icons.hirayaWText width="90" />
      </div>
    </div>
  )
}
